import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface MunicipalityState {
    elements:MunicipalityElement[]
}

export interface MunicipalityElement {

    _id: string,
    name:string,
    province:string,
    postalCode: string
}

const initialState: MunicipalityState= {
    elements: []
}

export const Municipality = createSlice({
    name:"municipality",
    initialState,
    reducers: {

        getAllElement : (state) => {},
        getAllElementSuccess: (state, actions: PayloadAction<MunicipalityElement[]>) => {
            state.elements = actions.payload
        },
        getAllElementError: (state) => {},

        saveElement: (state, action: PayloadAction<{ data: MunicipalityElement,callback: () => void }>) => {},
        saveElementSuccess: (state, actions: PayloadAction<MunicipalityElement>) => {
            state.elements.push(actions.payload)
        },
        saveElementError: (state, action:PayloadAction<MunicipalityElement>) => {},

        updateElement: (state, actions: PayloadAction<{  data: MunicipalityElement ,callback: () => void  }>) => {},
        updateElementSuccess: (state, actions: PayloadAction<MunicipalityElement>) => {
            let index = state.elements.findIndex(element => element.name === actions.payload.name)
            state.elements[index] = actions.payload
        },
        updateElementError: () => {},

        deleteElement: (state, action: PayloadAction<{_id:string,callback: () => void}>) => {},
        deleteElementSuccess: (state, action: PayloadAction<string>) => {},
        deleteElementError: () => {},
    }
})
    export const {
    getAllElement,
    getAllElementSuccess,
    getAllElementError,
    saveElement,
    saveElementSuccess,
    saveElementError,
    updateElement,
    updateElementSuccess,
    updateElementError,
    deleteElement,
    deleteElementSuccess,
    deleteElementError
    } = Municipality.actions

export default Municipality.reducer


